"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class ListSelection {
    level = 0;
    listCollection = [];
    selectedItems = [];
    options;
    element;
    main_wrapper = document.createElement('div');
    input_wrapper = document.createElement('div');
    parent_wrapper = document.createElement('div');
    list_wrapper = document.createElement('div');
    icons = {
        check: `<svg data-name="check" class="checkbox-icon" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="13" height="13" viewBox="0,0,256,256">
<g fill="#ffffff" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><g transform="scale(5.12,5.12)"><path d="M41.9375,8.625c-0.66406,0.02344 -1.27344,0.375 -1.625,0.9375l-18.8125,28.78125l-12.1875,-10.53125c-0.52344,-0.54297 -1.30859,-0.74609 -2.03125,-0.51953c-0.71875,0.22266 -1.25391,0.83203 -1.37891,1.57422c-0.125,0.74609 0.17578,1.49609 0.78516,1.94531l13.9375,12.0625c0.4375,0.37109 1.01563,0.53516 1.58203,0.45313c0.57031,-0.08594 1.07422,-0.41016 1.38672,-0.89062l20.09375,-30.6875c0.42969,-0.62891 0.46484,-1.44141 0.09375,-2.10547c-0.37109,-0.66016 -1.08594,-1.05469 -1.84375,-1.01953z"></path></g></g>
</svg>`,
        angle: `<svg data-name="angle" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" fill="none" stroke="currentColor" height="15px" stroke-width="12">
                        <path d="M30 10 L70 50 L30 90" />
                    </svg>`,
        minus: `<svg data-name="progress" class="progress-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="#fff"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path fill-rule="evenodd" clip-rule="evenodd" d="M6.00001 11.25L18 11.25L18 12.75L6.00001 12.75L6.00001 11.25Z" fill="#fff"></path> </g></svg>`
    };
    input = document.createElement('input');
    constructor(element, options) {
        this.element = element;
        this.options = options;
        this.options ? this.#init(this.options) : null;
    }
    #init(config) {
        this.main_wrapper.className = 'list-main-container';
        this.input.setAttribute('type', 'text');
        this.input.placeholder = this.options.placeholderText;
        this.input.addEventListener('input', (e) => {
            const searchTerm = e.target.value.trim().toLowerCase();
            if (searchTerm) {
                this.#search(searchTerm);
            }
            else {
                this.#clearSearch();
            }
        });
        this.parent_wrapper.className = 'parent-wrapper';
        const wrapperContainer = document.createElement('div');
        wrapperContainer.className = 'wrapper-container';
        this.list_wrapper.className = 'list-wrapper';
        this.input_wrapper.className = 'input-wrapper';
        wrapperContainer.appendChild(this.parent_wrapper);
        this.main_wrapper.appendChild(this.input);
        this.main_wrapper.appendChild(wrapperContainer);
        this.main_wrapper.appendChild(this.input_wrapper);
        this.element.appendChild(this.main_wrapper);
        if (config.data) {
            this.#initializeData(config.data);
        }
        else {
            console.error("No data provided for the Hierarchical List.");
        }
    }
    #search(searchTerm) {
        let allItems = Array.from(this.parent_wrapper.querySelectorAll('.list-wrapper'));
        allItems.forEach((item) => {
            let itemVal = item.getAttribute('data-name')?.trim().toLowerCase();
            if (itemVal) {
                let isMatch = itemVal.toLowerCase().trim().includes(searchTerm.toLowerCase().trim());
                if (isMatch) {
                    item.parentList?.classList.remove('hidden');
                    item.classList.remove('hidden');
                    this.#showChild(item, true);
                }
                else {
                    item.classList.add('hidden');
                    this.#showChild(item, false);
                }
            }
        });
    }
    #showChild(item, identifier) {
        const parentWrapper = item.parentElement?.parentElement;
        if (parentWrapper?.classList.contains('children')) {
            if (identifier) {
                parentWrapper?.classList.add('active');
                parentWrapper?.classList.add('shown');
            }
            else {
                this.#isAllChildHidden(parentWrapper) ? parentWrapper?.classList.add('active') : parentWrapper?.classList.remove('active');
            }
        }
    }
    #isAllChildHidden(wrapper) {
        const children = Array.from(wrapper.querySelectorAll('.list-wrapper'));
        return children.some((el) => {
            return !el.classList.contains('hidden');
        });
    }
    #clearSearch() {
        this.listCollection.forEach(item => {
            item.classList.remove('hidden');
            item.classList.remove('open');
            item.nextElementSibling?.classList.remove('active');
        });
    }
    #reset() {
        this.listCollection.forEach(item => {
            item.classList.remove('hidden');
            item.classList.remove('open');
            item.nextElementSibling?.classList.remove('active');
            item.querySelector('button')?.classList.contains('active') ? item.querySelector('button')?.classList.remove('active') : '';
        });
        this.input_wrapper.innerHTML = '';
        this.selectedItems = [];
        this.input.placeholder = this.options.placeholderText;
    }
    #initializeData(data) {
        const groupLabel = document.createElement('div');
        groupLabel.className = 'group-label';
        const labelTextWrapper = document.createElement('span');
        labelTextWrapper.textContent = `${this.options.levels ? this.options.levels[0] : 'Level 1'}`;
        groupLabel.appendChild(labelTextWrapper);
        if (this.options.allowSelectAll !== false) {
            const labelBtn = document.createElement('div');
            labelBtn.className = 'button';
            labelBtn.textContent = 'Select all';
            labelBtn.addEventListener('click', (e) => {
                this.listCollection.forEach((item) => {
                    if (!labelBtn.classList.contains('active')) {
                        if (item.hasAttribute('data-dropdown')) {
                            if (!item.querySelector('button')?.classList.contains('active')) {
                                item.click();
                            }
                        }
                    }
                    else {
                        if (item.querySelector('button')?.classList.contains('active')) {
                            this.#reset();
                        }
                    }
                });
                labelBtn.classList.contains('active') ? labelBtn.textContent = 'Select all' : labelBtn.textContent = 'deselect all';
                labelBtn.classList.toggle('active');
            });
            groupLabel.appendChild(labelBtn);
        }
        this.parent_wrapper.appendChild(groupLabel);
        data.forEach((item, index) => {
            let listItem = this.#generateList(item);
            if (listItem)
                this.parent_wrapper.appendChild(listItem);
        });
    }
    #generateList(dataObj, parent = undefined, layer = undefined) {
        const dropdownListWrapper = document.createElement('div');
        const listWrapper = document.createElement('div');
        dropdownListWrapper.list = listWrapper;
        dropdownListWrapper.className = 'dropdown-list-wrapper';
        listWrapper.className = 'list-wrapper';
        listWrapper.setAttribute('data-name', dataObj.name);
        listWrapper.setAttribute('data-value', String(dataObj.value));
        if (parent) {
            listWrapper.parentList = parent;
        }
        if (layer) {
            listWrapper.layer = layer;
        }
        else {
            listWrapper.activeChildLength = 0;
        }
        const listItem = document.createElement('div');
        listItem.className = 'list';
        const checkBtn = document.createElement('button');
        listWrapper.button = checkBtn;
        listWrapper.level = this.level;
        const listText = document.createElement('span');
        listText.textContent = dataObj.name;
        listItem.appendChild(checkBtn);
        listItem.appendChild(listText);
        listWrapper.appendChild(listItem);
        listWrapper.addEventListener('mousemove', (e) => {
            const willCollapse = this.#willSelect(listWrapper, e);
            if (willCollapse) {
                if (listWrapper.childLength) {
                    if (listWrapper.lastElementChild && !listWrapper.lastElementChild.classList.contains('highlight'))
                        listWrapper.lastElementChild.classList.add('highlight');
                    else if (listWrapper.firstElementChild?.classList.contains('highlight')) {
                        listWrapper.firstElementChild.classList.remove('highlight');
                    }
                }
                else {
                    listWrapper.firstElementChild?.classList.add('highlight');
                }
            }
            else {
                if (listWrapper.childLength) {
                    if (listWrapper.lastElementChild?.classList.contains('highlight'))
                        listWrapper.lastElementChild.classList.remove('highlight');
                    else if (!listWrapper.firstElementChild?.classList.contains('highlight'))
                        listWrapper.firstElementChild?.classList.add('highlight');
                }
                else {
                    listWrapper.firstElementChild?.classList.add('highlight');
                }
            }
        });
        listWrapper.addEventListener('mouseout', (e) => {
            if (listWrapper.firstElementChild?.classList.contains('highlight'))
                listWrapper.firstElementChild?.classList.remove('highlight');
            if (listWrapper.lastElementChild?.classList.contains('highlight'))
                listWrapper.lastElementChild?.classList.remove('highlight');
        });
        listWrapper.addEventListener('click', (e) => {
            const willCollapse = this.#willSelect(listWrapper, e);
            if (willCollapse && dataObj.children) {
                listWrapper.classList.toggle('open');
                if (listWrapper.classList.contains('open')) {
                    listWrapper.child?.classList.add('active');
                    listWrapper.child?.querySelectorAll('.list-wrapper').forEach(item => {
                        item.classList.remove('hidden');
                    });
                }
                else {
                    listWrapper.child?.classList.remove('active');
                }
            }
            else {
                this.#handleSelect(listWrapper);
                if (dataObj.children && dataObj.children.length > 0) {
                    let childWrapper = listWrapper.nextElementSibling;
                    if (childWrapper && childWrapper.classList.contains('children')) {
                        childWrapper.querySelectorAll('.list-wrapper').forEach((item) => {
                            if (listWrapper.querySelector('button')?.classList.contains('active')) {
                                listWrapper.querySelector('button')?.classList.contains('progress') ? listWrapper.querySelector('button')?.classList.remove('progress') : '';
                                if (!item.querySelector('button')?.classList.contains('active')) {
                                    let divItem = item;
                                    this.#handleSelect(divItem);
                                }
                            }
                            else {
                                listWrapper.querySelector('button')?.classList.contains('progress') ? listWrapper.querySelector('button')?.classList.remove('progress') : '';
                                if (item.querySelector('button')?.classList.contains('active')) {
                                    let divItem = item;
                                    this.#handleSelect(divItem);
                                }
                            }
                        });
                    }
                }
                else {
                    if (listWrapper.level == 1) {
                        const parentList = listWrapper.parentList;
                        if (parentList?.childLength) {
                            const activeChildLength = parentList.activeChildLength ?? 0;
                            if (activeChildLength === parentList.childLength) {
                                parentList.querySelector('button')?.classList.add('active');
                                parentList.querySelector('button')?.classList.remove('progress');
                            }
                            else if (activeChildLength <= 0) {
                                parentList.querySelector('button')?.classList.remove('progress');
                                parentList.querySelector('button')?.classList.remove('active');
                            }
                            else {
                                parentList.querySelector('button')?.classList.add('progress');
                                parentList.querySelector('button')?.classList.remove('active');
                            }
                        }
                    }
                }
                const selectedCount = this.selectedItems.length;
                if (selectedCount > 0) {
                    this.input.placeholder = `Selected ${selectedCount} item${selectedCount > 1 ? 's' : ''}`;
                }
                else {
                    this.#reset();
                }
            }
        });
        if (dataObj.selected) {
            listWrapper.click();
        }
        dropdownListWrapper.appendChild(listWrapper);
        if (dataObj.children && dataObj.children.length > 0) {
            listWrapper.setAttribute('data-dropdown', 'true');
            this.level++;
            let parentList = listWrapper;
            listWrapper.childLength = dataObj.children.length;
            listWrapper.innerHTML += `<span data-name="angle" class="material-symbols-rounded">arrow_forward_ios</span>`;
            const childWrapper = document.createElement('div');
            const groupLabel = document.createElement('div');
            groupLabel.className = 'group-label';
            const labelTextWrapper = document.createElement('span');
            labelTextWrapper.textContent = `${this.options.levels ? this.options.levels[1] : 'Level 2'}`;
            groupLabel.appendChild(labelTextWrapper);
            childWrapper.className = 'children';
            listWrapper.child = childWrapper;
            childWrapper.appendChild(groupLabel);
            dataObj.children.forEach((item) => {
                const childItem = this.#generateList(item, parentList, 'child');
                if (childItem) {
                    childWrapper.appendChild(childItem);
                }
            });
            dropdownListWrapper.appendChild(childWrapper);
            this.level--;
        }
        if (dataObj.active) {
            this.listCollection.push(dropdownListWrapper.list);
            return dropdownListWrapper;
        }
        else {
            return;
        }
    }
    #updateParentActiveCount(child, change) {
        let parent = child.parentList;
        while (parent) {
            parent.activeChildLength = (parent.activeChildLength || 0) + change;
            if (parent.activeChildLength < 0) {
                parent.activeChildLength = 0;
            }
            parent = parent.parentList;
        }
    }
    #willSelect(wrapper, event) {
        let wrapperPosition = wrapper.getBoundingClientRect();
        let mousePosition = event.clientX;
        let halfWrapperDistance = wrapperPosition.left + wrapper.clientWidth / 2;
        return mousePosition > halfWrapperDistance;
    }
    #handleSelect(list) {
        const valueAttr = list.getAttribute('data-value');
        const value = valueAttr ? Number(valueAttr) : null;
        const name = list.getAttribute('data-name');
        const level = list.level || 0;
        let key = this.options.keys[level];
        const isAlreadySelected = this.selectedItems.some((item) => item.name === name && item.value === value && item.key === key);
        if (isAlreadySelected) {
            this.selectedItems = this.selectedItems.filter((item) => !(item.name === name && item.value === value && item.key === key));
            this.#updateParentActiveCount(list, -1);
        }
        else {
            if (value !== null && !isNaN(value)) {
                this.selectedItems.push({ key, name, value });
            }
            this.#updateParentActiveCount(list, 1);
        }
        list.querySelector('button')?.classList.toggle('active');
        this.#createFormInput();
    }
    #createFormInput() {
        const values = this.getValues();
        Object.keys(values).forEach(key => {
            let existingInput = this.input_wrapper.querySelector(`input[name="${key}"]`);
            const selectedValues = values[key];
            if (existingInput) {
                existingInput.value = JSON.stringify(selectedValues);
            }
            else {
                const input = document.createElement('input');
                input.type = 'hidden';
                input.name = key;
                input.value = JSON.stringify(selectedValues);
                this.input_wrapper.appendChild(input);
            }
        });
    }
    getFullValue() {
        const values = {};
        this.selectedItems.forEach((item) => {
            const { key, name, value } = item;
            if (!values[key]) {
                values[key] = [];
            }
            values[key].push({ name, value });
        });
        return values;
    }
    getValues() {
        const values = {};
        this.selectedItems.forEach((item) => {
            const { key, name, value } = item;
            if (!values[key]) {
                values[key] = [];
            }
            values[key].push(value);
        });
        return values;
    }
}
exports.default = ListSelection;
